import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class Currency {
  constructor (params = {}) {
    const {
      id,
      sequence,
      name,
      type,
      displayName,
      externalIds
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.name = name || null
    this.type = type || null
    this.displayName = displayName || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.defaultExchangeRate = null
    this.exchangeRates = []
  }
}
